import { render, staticRenderFns } from "./BoxLineDrawer.vue?vue&type=template&id=bffb62f4&scoped=true&"
import script from "./BoxLineDrawer.vue?vue&type=script&lang=ts&"
export * from "./BoxLineDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./BoxLineDrawer.vue?vue&type=style&index=0&id=bffb62f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffb62f4",
  null
  
)

export default component.exports